<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("configuracion")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-4" v-if="grupoProducto">
                <h2><i class="fa fa-th-large"></i> {{$t("frontalDeVentas")}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="productos" :to="{name:'productos'}">
                                <li>{{$t("productos")}}<br>
                                    <span class="text-muted"><strong>{{$t('componentesDeVenta')}}</strong> {{$t('delNegocioAClientes')}}</span>
                                </li>
                            </router-link>
                            <!-- Pantalla de Categorias rehecha: RENOVADO por el mismo motivo que
                                 Etiquetas del negocio, la opcion ya existia y cambia la pantalla. -->
                            <novedad-highlight v-if="categorias" :etiqueta="$t('renovado')" hasta="2026-12-31">
                                <router-link :to="{name:'categorias-negocio'}">
                                    <li>{{$t('categorias')}}<br>
                                        <span class="text-muted">{{$t('clasificacionDe')}} <strong>{{$t('productosPorFamilia')}}</strong></span>
                                    </li>
                                </router-link>
                            </novedad-highlight>
                            <router-link v-if="modificadores && soloRetail" :to="{name:'modificadores'}">
                                <li>{{$t('modificadores')}}<br>
                                    <span class="text-muted">{{$t('elementosQue')}} <strong>{{$t('varianALosProductos')}}</strong> {{$t('paraLaComanda')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="!businessCentral" :to="{name:'importacion-sage'}">
                                <li>{{tieneDimoni ? $t('importacionContable') : $t('importacionSage')}}<br>
                                    <span class="text-muted">{{$t('configuracionParaLaImportacionExportacionDeDatosDeSage')}}</span>
                                </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="grupoCompra">
                <h2><i class="fa fa-briefcase"></i> {{$t('gastos')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="materiaPrima" :to="{name:'subproductos'}">
                                <li> {{$t("subproductos")}}<br>
                                    <span class="text-muted"><strong>{{$t('componentesComprados')}}</strong> {{$t('aProveedoresQueComponenProductos')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="proveedores" :to="{name:'proveedores'}">
                                <li> {{$t("proveedores")}}<br>
                                    <span class="text-muted">{{$t('empresas')}} <strong>{{$t('proveedorasDeMateriasPrimasYServicios')}}</strong> {{$t('alNegocio')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="casas" :to="{name:'casas'}">
                                <li> {{$t("casas")}}<br>
                                    <span class="text-muted">{{$t('empresas')}} <strong>{{$t('fabricantesDeMateriasPrimas')}}</strong> {{$t('aProveedores')}}</span>
                                </li>
                            </router-link>
                            <!-- Aqui estaba la pantalla vieja de etiquetas. Se retira: su ruta
                                 redirige a esta, que es la unica desde ahora. Va señalada como
                                 RENOVADO y no como NUEVO: la opcion estaba, lo que cambia es la
                                 pantalla, y quien la usaba tiene que saber que no es la de antes. -->
                            <novedad-highlight v-if="etiquetas" :etiqueta="$t('renovado')" hasta="2026-12-31">
                                <router-link :to="{name:'etiquetas-negocio'}">
                                    <li> {{$t("etiquetasDelNegocio")}}<br>
                                        <span class="text-muted"><strong>{{$t('etiquetasClasifican')}}</strong> {{$t('etiquetasDosFamilias')}}</span>
                                    </li>
                                </router-link>
                            </novedad-highlight>
                            <router-link :to="{ name: 'taxes' }">
                            <li>
                                {{$t("gestionImpuestos")}}<br>
                                <span class="text-muted">{{ $t('administracionTiposTasas') }}<strong>{{$t('administracionTiposTasasImpositivas')}}</strong></span>
                            </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="operarios">
                <h2><i class="fa fa-user-alt"></i> {{$t('operarios')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="operarios" :to="{name:'operarios'}">
                                <li> {{$t("operarios")}}<br>
                                    <span class="text-muted">{{$t('personalCon')}} <strong>{{$t('acceso')}}</strong> {{$t('alSistema')}}</span></li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="clientes">
                <h2><i class="fa fa-users"></i> {{$t('clientes')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="clientes" :to="{name:'clientes'}">
                                <li> {{$t('clientes')}}<br>
                                    <span class="text-muted">{{$t('baseDeDatosDe')}} <strong>{{$t('consumidores')}}</strong> {{$t('enElNegocio')}}</span>
                                </li>
                            </router-link>
                            <!-- <router-link v-if="clientes" :to="{name:'categorias-clientes'}">
                                <li>Categorias clientes<br>
                                    <span class="text-muted"><strong>Categorías que clasifican</strong> clientes</span>
                                </li>
                            </router-link> -->
                        </ul>
                    </div>
                </card>
            </div>


            <div class="col-md-4" v-if="agencias">
                <h2><i class="fa fa-male"></i> {{$t('agencias')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="agencias" :to="{name:'agencias'}">
                                <li> {{$t('agencias')}}<br>
                                    <span class="text-muted">{{$t('clasificacionDeLa')}} <strong>{{$t('procedencia')}}</strong> {{$t('deLasVentas')}}</span>
                                </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="formasPago">
                <h2><i class="fas fa-credit-card"></i> {{$t('formasDePago')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="formasPago" :to="{name:'formas-de-pago'}">
                                <li> {{$t('formasDePago')}}<br>
                                    <span class="text-muted"><strong>{{$t('metodosDeCobro')}}</strong> {{$t('enElFrontalDeVenta')}}</span>
                                </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="rangoHorarios">
                <h2><i class="fas fa-chalkboard-teacher"></i> {{$t('general')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <!--
                            <router-link :to="{name:'datos-fiscales'}">
                                <li>Datos fiscales<br>
                                    <span class="text-muted">Configuracion de datos fiscales para informes</span></li>
                            </router-link>
                            -->
                            <router-link :to="{name:'rangos-horarios'}">
                                <li>{{$t('rangosHorarios')}}<br>
                                    <span class="text-muted">{{$t('intervaloDeHorasParaConsultarVentas')}}</span></li>
                            </router-link>
                            <router-link v-if="soloRetail" :to="{name:'rangos-de-mesas'}">
                                <li>{{$t('rangosDeMesas')}}<br>
                                    <span class="text-muted">{{$t('agrupacionesDeMesasParaConsultarVentas')}}</span></li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="almacen">
                <h2><i class="fas fa-warehouse"></i> {{$t('almacen')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link :to="{name:'configuracion-almacen'}">
                                <li>{{$t('configurarAlmacén')}}<br>
                                    <span class="text-muted">{{$t('relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen')}}</span></li>
                            </router-link>

                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="grupoProducto">
                <h2><i class="fas fa-cog"></i> {{$t('herramientas')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link :to="{name:'herramientas'}">
                                <li>{{$t('herramientasGenerales')}}<br>
                                    <span class="text-muted">{{$t('edicionMasiva')}}</span></li>
                            </router-link>

                        </ul>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
    import NovedadHighlight from '../../../components/Novedad/NovedadHighlight.vue';

    export default {
        components: { NovedadHighlight },

        created() {
            this.$store.dispatch("setNameRoute", "Configuración");
            this.restrictions();
            this.tieneBusinessCentral();
            this.getConfigDimoni();
            this.getTpvsRetail();
            
            if (localStorage.getItem('visitedTaxes') === 'true') {
                this.visitedTaxes = true; 
            }
        },
        data() {
            return {
                //COMPRAS
                materiaPrima: true,
                proveedores: true,
                etiquetas: true,

                grupoCompra: true,

                //PRODUCTOS
                productos: true,
                categorias: true,
                modificadores: true,

                grupoProducto: true,

                //CLIENTES
                clientes: true,

                //CASAS
                casas: true,

                //OPERARIOS
                operarios: true,

                //AGENCIAS
                agencias: true,

                //FORMAS DE PAGO
                formasPago: true,

                //ALMACEN
                almacen:true,

                //RANGO HORARIOS
                rangoHorarios:true,

                //SAGE
                idsBusiness: [],
                idsTPV: [],

                //DIMONI
                tieneDimoni: false,
                //RETAIL
                soloRetail: true,

                //IMPUESTOS
                gestionImpuestos: true,

                // NOVEDAD
                visitedTaxes: false,

                //BUSINESS CENTRAL
                businessCentral: false,
                

            }
        },
        methods: {
            /*getSageBusinessData()  {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "importacion/getSageBusinessDataByUser", config)
                    .then(function (response) {

                        if(response.data.result.length > 0) {
                            vm.tieneSageBusiness = true;
                        } 

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },*/

            getConfigDimoni() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(
                        this.$store.getters.apiUrl + "clients/tieneDimoni",
                        config
                    ).then(function(response) {
                        if (response.data.result) {
                            vm.tieneDimoni=true;       
                        } else {
                            vm.tieneDimoni=false;   
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            getTpvsRetail(){
                var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "tpvs/getTpvsRetail", config)
                    .then(function (response) {
                        if(response.data.result){
                            vm.soloRetail = false;
                        }else{
                            vm.soloRetail = true;
                        }
                    })
            },
            restrictions() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByUser", config)
                    .then(function (response) {

                        if (response.data.response) {

                            for (let i = 0; i < response.data.result.length; i++) {

                                switch (response.data.result[i].idRestriction) {

                                    case 9:
                                        vm.materiaPrima = false;
                                        break;
                                    case 10:
                                        vm.proveedores = false;
                                        break;
                                    case 11:
                                        vm.etiquetas = false;
                                        break;
                                    case 12:
                                        vm.productos = false;
                                        break;
                                    case 13:
                                        vm.categorias = false;
                                        break;
                                    case 14:
                                        vm.modificadores = false;
                                        break;
                                    case 15:
                                        vm.clientes = false;
                                        break;
                                    case 16:
                                        vm.casas = false;
                                        break;
                                    case 17:
                                        vm.operarios = false;
                                        break;
                                    case 18:
                                        vm.agencias = false;
                                        break;
                                    case 19:
                                        vm.formasPago = false;
                                        break;
                                    case 49:
                                        vm.almacen = false;
                                        break;
                                    case 51:
                                        vm.rangoHorarios = false;
                                        break;
                                }
                            }

                            if (!vm.materiaPrima && !vm.proveedores && !vm.etiquetas) {
                                vm.grupoCompra = false;
                            }

                            if (!vm.productos && !vm.categorias && !vm.modificadores) {
                                vm.grupoProducto = false;
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            
            tieneBusinessCentral() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(
                    this.$store.getters.apiUrl + "general/getRestrictionsByUser",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {

                            switch (response.data.result[i].idRestriction) {
                                case "76":
                                    vm.businessCentral = true;
                                    break;
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        }
    }
</script>
<style scoped>

    h2 {
        margin: 10px 0px;
        font-family: "Numier", "Helvetica Neue", Arial;
        color: #1E22AA;
        font-size: 25px;
        font-weight: bold;
    }

    i {
        font-size: 25px
    }

    .list-files {
        padding: 0;
        margin-bottom: 0px;
    }

    .list-files a:first-child li {
        border-top: none;
    }

    .list-files a li {
        list-style: none;
        padding: 15px 20px;
        font-size: 1.1em;
        border-top: 1px solid #bbb;
        color: #252422;
    }

    .list-files a li span {
        font-size: 0.7em;
    }

    .list-files a li:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.2);
    }

    .content-card {
        /* border-top: 2px solid #00A3AD; */
        border-top: 2px solid #00A3AD;
        padding: 0;
    }

    /* El resaltado de secciones nuevas vive ahora en components/Novedad/NovedadHighlight.vue */

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Configuracion.vue